import { render, staticRenderFns } from "./UpdateList.vue?vue&type=template&id=d1c5f81e"
import script from "./UpdateList.vue?vue&type=script&lang=js"
export * from "./UpdateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports